import { jsx, jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import { Typography } from "@mui/material";
import "lottie-react";
import { Avatar } from "../../../../../components/avatar/avatar.js";
import "../../../../../components/avatar-group/avatar-group.styles.js";
import "../../../../../themes/shadows/shadows.js";
import "../../../../../themes/typography/typography.js";
import "../../../../../components/date-pickers/pickers-action-bar/pickers-action-bar.js";
import "../../../../../components/date-pickers/date-picker/theme/index.js";
import "../../../../../components/dialog/dialog.js";
import "../../../../../components/icons/all/all.js";
import { ClockIcon } from "../../../../../components/icons/ClockIcon/ClockIcon.js";
import "../../../../../components/label/label.styles.js";
import "../../../../../components/menu-item/menu-item.js";
import "../../../../../components/slider/slider.styles.js";
import "@mui/material/styles";
import "../../../../../components/snackbar/snackbar.styles.js";
import "../../../../../components/styled-text-field/styled-text-field.styles.js";
import "../../../../../components/swipeable-drawer/swipeable-drawer.js";
import "../../../../../components/translations/utils.js";
import "../../../../../components/time-select/time-select.styles.js";
import "../../../../../components/time-interval-select/time-interval-select.styles.js";
import { DATE_FORMATS } from "../../../../../constants/date/date.js";
import { TIME_FORMATS } from "../../../../../constants/time/time.js";
import { format, parseISO } from "date-fns";
import "lodash";
import "../../../../components/appointments-picker/appointments-picker.styles.js";
import "clsx";
import "../../../../components/appointments-picker/components/AvailableSlot/AvailableSlot.styles.js";
import "../../../../components/appointments-picker/components/CurrentPeriod/CurrentPeriod.styles.js";
import "../../../../components/appointments-picker/components/NextPeriod/NextPeriod.styles.js";
import "../../../../components/appointments-picker/components/PrevPeriod/PrevPeriod.styles.js";
import "../../../../components/appointments-picker/components/QuickFilter/QuickFilter.styles.js";
import "../../../../components/appointments-picker/components/TimeFrames/TimeFrames.styles.js";
import "../../../../components/appointments-picker/components/UnavailableSlot/UnavailableSlot.styles.js";
import "../../../../components/appointments-picker/components/WorkingDay/WorkingDay.styles.js";
import "color-alpha";
import "../../../../../themes/external-theme/external-theme.js";
import "../../../../../themes/pickers-popper/pickers-popper.js";
import "../../../../components/chemistry-info/chemistry-info.styles.js";
import "../../../../components/clinic-location-details/clinic-location-details.styles.js";
import "../../../../components/clinic-location-details/Day/styles.js";
import "../../../../components/clinic-location-details/Map/Map.js";
import "../../../../components/floating-button/floating-button-container/styles.js";
import "../../../../components/floating-button/floating-button.styles.js";
import "../../../../components/news-section/news-section.styles.js";
import { ObfuscatedText } from "../../../../components/obfuscated-text/obfuscated-text.js";
import "../../../../components/pain-details-form/pain-details-form.styles.js";
import "../../../../components/pain-details-form/constants/constants.js";
import "react-slick";
import "../../../../components/task-form/components/Avatar/Avatar.styles.js";
import "../../../../components/task-form/components/Comments/Comments.styles.js";
import "lodash/debounce.js";
import "../../../../components/task-form/components/DatePicker/DatePicker.styles.js";
import "../../../../components/task-form/components/EmployeeMenuItem/EmployeeMenuItem.styles.js";
import "../../../../components/task-form/components/EmployeesDropdown/EmployeesDropdown.styles.js";
import "../../../../components/task-form/components/PatientAutocomplete/PatientAutocomplete.styles.js";
import "@hookform/resolvers/yup";
import "../../../../components/task-form/task-form.entities.js";
import "../../../../components/task-form/task-form.styles.js";
import "../../../../components/task-form/theme/index.js";
import "../../../../components/team-section/constants/constants.js";
import "../../../../components/team-section/components/Rating/styles.js";
import "../../../../components/team-section/team-section.styles.js";
import "../../../../components/testimonials-section/constants.js";
import "../../../../components/testimonials-section/PractitionerTestimonialCard/styles.js";
import "../../../../components/testimonials-video-section/testimonials-video-section.styles.js";
import "../../../../components/employee-select/employee-select.js";
import "../../../../components/ana/utils/shared/Checkbox.js";
import "../../../../components/ana/utils/shared/FormControlLabel.js";
import "../../../../components/ana/components/translate/translate.js";
import "../../../../components/ana/components/checklist-input/checklist-input.styles.js";
import "react-dom";
import "../../../../components/ana/components/address-field/address-field.js";
import "../../../../components/ana/utils/hooks/useFormHelpers.js";
import "../../../../components/ana/utils/hooks/useSubmitCount.js";
import "../../../../components/ana/utils/yup/main.js";
import "../../../../components/ana/components/checkbox-field/checkbox-field.styles.js";
import "../../../../components/ana/components/date-picker-field/date-picker-field.js";
import "../../../../components/ana/components/phone-field/phone-field.js";
import "../../../../components/ana/components/radio-group/radio-group.js";
import "../../../../components/ana/utils/shared/TextFieldLabel.js";
import "../../../../components/ana/components/field-helper-text/field-helper-text.js";
import "../../../../components/ana/components/select-input/select-input.styles.js";
import "../../../../components/ana/components/text-input/text-input.js";
import "../../../../components/ana/components/toggle-field/toggle-field.js";
import "../../../../components/ana/utils/hooks/useFormValue.js";
import "../../../../components/ana/components/form-layout/form-layout.styles.js";
import "../../../../components/ana/utils/shared/Button.js";
import "../../../../components/ana/components/submit-button/submit-button.styles.js";
import "../../../../components/ana/components/toggle-multi-checkbox/toggle-multi-checkbox.styles.js";
import "../../../../components/ana/utils/config/diseases.js";
import "../../../../components/ana/utils/fields/allergiesAndMedications.js";
import "../../../../components/ana/components/insurance-field/insurance-field.js";
import "../../../../components/ana/utils/fields/insurance.js";
import "../../../../components/ana/utils/shared/SectionTitle.js";
import "yup";
import "../../../../components/ana/components/callout/Callout.styles.js";
import "../../../../components/ana/utils/types/contentful.js";
import "../../../../components/ana/utils/fields/contactDetails.js";
import "../../../../components/ana/utils/shared/AddressLayoutItem.js";
import "../../../../components/ana/forms/miscellaneous/miscellaneous.js";
import "../../../../components/ana-toolbox/ana-toolbox.js";
import "../../../../components/ana/utils/config/wishes.js";
import "../../../../components/ana/utils/shared/Radio.js";
import "../../../../components/ana/utils/shared/RadioFormControl.js";
import "../../../../components/ana/utils/shared/RadioFormControlLabel.js";
import "../../../../components/ana/utils/shared/RadioFormLabel.js";
import "../../../../components/ana/utils/shared/RadioGroup.js";
import "../../../../components/ana/utils/shared/ToggleContainer.js";
import "../../../../components/ana/utils/shared/ToggleFormControlLabel.js";
import "../../../../components/ana/forms/preconditions/preconditions.js";
import "../../../../components/ana/components/legal-representative-dialog/legal-representative-dialog.styles.js";
import "../../../../components/ana/utils/fields/personalInformation.js";
import "../../../../components/ana/utils/helpers/DiseaseType.js";
import "../../../../components/ana/utils/shared/TextField.js";
import "../../../../components/ana/components/tag/tag.styles.js";
import "../../../../components/ana/components/disease-field/disease-field.styles.js";
import "../../../../components/ana/components/disease-group-field/disease-group-field.styles.js";
import "../../../../components/ana/utils/helpers/i18n.js";
import "../../../../components/ana/components/ana-dialog/ana-dialog.styles.js";
import "../../../../components/ana/utils/shared/Modal.js";
import "../../../../components/ana/utils/fields/miscellaneous.js";
import "../../../../components/ana/utils/config/wishesAndExpectations.js";
import "../../../../../hooks/useFilterEmployees/useFilterEmployees.js";
import "../../../../components/website/common/button/styles.js";
import "../../../../components/website/jobs/job-description-section/styles.js";
import "../../../../components/website/jobs/job-details-hero-section/styles.js";
import "../../../../components/website/directions-section/styles.js";
import "react-headroom";
import "../../../../components/page-header/context/header-context.js";
import "../../../../components/page-header/components/header-skip/styles.js";
import "../../../../../components/expandable/expandable-dropdown/expandable-dropdown.styles.js";
import "../../../../../components/expandable/expandable-group/expandable-group-context.js";
import "../../../../components/page-header/page-header-mobile/page-header-mobile-content/styles.js";
import "query-string";
import "../../../../components/authentication/components/CredentialsProvider.js";
import "../../../../components/authentication/services/api.js";
import "../../../../components/authentication/components/RouterProvider.js";
import "../../../../components/authentication/components/SecurityConfigProvider.js";
import "../../../../components/authentication/services/i18n.js";
import "../../../../components/authentication/components/auth-container/auth-container.styles.js";
import "../../../../components/authentication/components/login-page/login-page.styles.js";
import "../../../../components/authentication/components/TrustedDeviceProvider.js";
import "../../../../components/authentication/components/HistoryProvider.js";
import { CancellationReasonIcon } from "../../assets/icons/CancellationReason.js";
import { CancellationTypeIcon } from "../../assets/icons/CancellationType.js";
import { CancellationUserIcon } from "../../assets/icons/CancellationUser.js";
import { CommentIcon } from "../../assets/icons/Comment.js";
import { CreatedByIcon } from "../../assets/icons/CreatedBy.js";
import { InsuranceIcon } from "../../assets/icons/Insurance.js";
import { MailIcon } from "../../assets/icons/Mail.js";
import { PatientIcon } from "../../assets/icons/Patient.js";
import { PhoneIcon } from "../../assets/icons/Phone.js";
import { TreatmentIcon } from "../../assets/icons/Treatment.js";
import { WarningIcon } from "../../assets/icons/WarningIcon.js";
import { insertIf, getNameInitials } from "../../helpers/common.js";
import { AppointmentInfoSkeleton } from "./appointment-info.skeleton.js";
import { CancelationDetailsContainer, Container, IconContainer, PatientDetailsContainer, PatientAdditionalDetails, RiskyAppointmentWarning, AvatarContainer, Warning, MainText, DetailsWrapper } from "./appointment-info.styles.js";
import "@mui/material/Avatar/index.js";
import "../../../../../components/avatar/avatar.styles.js";
import "../../../../../themes/typography/utils/defaultVariantMapping/defaultVariantMapping.js";
import "../../../../../themes/typography/utils/typographyVariants/typographyVariants.js";
import "@mui/system";
import "@mui/material/Button/index.js";
import "@mui/x-date-pickers/internals/index.js";
import "../../../../../constants/create-theme/create-theme.js";
import "../../../../../constants/colors/palette.js";
import "../../../../../themes/button/button.js";
import "../../../../../themes/button/styles/external/bordered.styles.js";
import "../../../../../themes/button/styles/external/filled.styles.js";
import "../../../../../themes/button/styles/internal/bordered.styles.js";
import "../../../../../themes/button/styles/internal/borderless.styles.js";
import "../../../../../themes/button/styles/internal/filled.styles.js";
import "../../../../../themes/button/styles/internal/shadowed.styles.js";
import "../../../../../components/date-pickers/pickers-action-bar/pickers-action-bar.styles.js";
import "../../../../../themes/date-calendar/date-calendar.js";
import "../../../../../themes/date-picker-toolbar/date-picker-toolbar.js";
import "../../../../../themes/day-calendar/day-calendar.js";
import "../../../../../themes/filled-input/filled-input.js";
import "../../../../../themes/form-helper-text/form-helper-text.js";
import "../../../../../themes/form-label/form-label.js";
import "../../../../../themes/month-calendar/month-calendar.js";
import "../../../../../themes/pickers-arrow-switcher/pickers-arrow-switcher.js";
import "../../../../../themes/pickers-calendar-header/pickers-calendar-header.js";
import "../../../../../themes/pickers-day/pickers-day.js";
import "@mui/x-date-pickers";
import "../../../../../themes/pickers-month/pickers-month.js";
import "../../../../../themes/pickers-toolbar/pickers-toolbar.js";
import "../../../../../themes/pickers-year/pickers-year.js";
import "../../../../../themes/year-calendar/year-calendar.js";
import "@mui/icons-material/Close.js";
import "../../../../../themes/alert/alert.js";
import "../../../../../themes/alert/components/ErrorIcon/ErrorIcon.js";
import "@mui/material/SvgIcon/index.js";
import "../../../../../themes/alert/components/InfoIcon/InfoIcon.js";
import "../../../../../themes/alert/components/SuccessIcon/SuccessIcon.js";
import "../../../../../themes/alert/components/WarningIcon/WarningIcon.js";
import "../../../../../themes/dialog/dialog.js";
import "../../../../../themes/popover/popover.js";
import "../../../../../themes/radio/radio.js";
import "../../../../../themes/switch/switch.js";
import "../../../../../themes/tooltip/tooltip.js";
import "../../../../../components/dialog/dialog.constants.js";
import "../../../../../components/dialog/dialog.styles.js";
import "@emotion/react";
import "../../../../../components/dialog/DraggablePaperComponent.js";
import "react-draggable";
import "../../../../../constants/breakpoints/breakpoints.js";
import "../../../../../themes/checkbox/checkbox.js";
import "../../../../../themes/checkbox/components/CheckedIcon/CheckedIcon.js";
import "../../../../../themes/checkbox/components/IndeterminateIcon/IndeterminateIcon.js";
import "../../../../../themes/form-control-label/form-control-label.js";
import "../../../../../components/icons/CalendarEventIcon/CalendarEventIcon.js";
import "../../../../../components/icons/MainIcon/MainIcon.js";
import "../../../../../components/icons/CalendarIcon/CalendarIcon.js";
import "../../../../../components/icons/CardIcon/CardIcon.js";
import "../../../../../components/icons/ChecklistIcon/ChecklistIcon.js";
import "../../../../../components/icons/CloseIcon/CloseIcon.js";
import "../../../../../components/icons/EditIcon/EditIcon.js";
import "../../../../../components/icons/EmptyCalendar/EmptyCalendar.js";
import "../../../../../components/icons/EventNote/EventNote.js";
import "../../../../../components/icons/FilterIcon/FilterIcon.js";
import "../../../../../components/icons/ListIcon/ListIcon.js";
import "../../../../../components/icons/MessageBubble/MessageBubble.js";
import "../../../../../components/icons/PhoneIcon/PhoneIcon.js";
import "../../../../../components/icons/PinIcon/PinIcon.js";
import "../../../../../components/icons/SearchIcon/SearchIcon.js";
import "../../../../../components/icons/TherapyNotesIcon/TherapyNotesIcon.js";
import "../../../../../components/icons/TimerIcon/TimerIcon.js";
import "../../../../../components/icons/TreatmentChairIcon/TreatmentIcon.js";
import "../../../../../components/icons/VisibilityOffIcon/VisibilityOffIcon.js";
import "../../../../../components/icons/WarningIcon/WarningIcon.js";
import "@mui/material/MenuItem/index.js";
import "../../../../../components/menu-item/components/menu-item-counter/menu-item-counter.js";
import "../../../../../components/menu-item/assets/icons/minus-circle.js";
import "../../../../../components/menu-item/assets/icons/plus-circle.js";
import "../../../../../components/menu-item/components/menu-item-counter/menu-item-counter.styles.js";
import "../../../../../components/menu-item/menu-item.styles.js";
import "@mui/material/Snackbar/index.js";
import "../../../../../components/snackbar/snackbar.types.js";
import "../../../../../components/text-field/text-field.js";
import "@mui/material/TextField/index.js";
import "../../../../../components/text-field/text-field.styles.js";
import "../../../../../components/swipeable-drawer/swipeable-drawer.styles.js";
import "react-i18next";
import "../../../../../type/Translations.js";
import "contentful";
import "i18next";
import "lodash/set.js";
import "remarkable";
import "remarkable-react";
import "@mui/icons-material/Timer.js";
import "@mui/material/FormControl/index.js";
import "@mui/material/InputLabel/index.js";
import "@mui/material/Select/index.js";
import "@mui/material/Box/index.js";
import "@mui/icons-material/ArrowBackIos.js";
import "@mui/icons-material/ExpandMore.js";
import "@mui/material/Card/index.js";
import "@mui/material/CardContent/index.js";
import "@mui/icons-material/KeyboardArrowRight.js";
import "@mui/icons-material/KeyboardArrowLeft.js";
import "google-map-react";
import "../../../../components/obfuscated-text/obfuscated-text.styles.js";
import "../../../../components/pain-details-form/types.js";
import "../../../../components/task-form/assets/icons/Avatar.js";
import "../../../../components/task-form/assets/icons/Logo.js";
import "../../../../components/task-form/assets/icons/Comment.js";
import "../../../../components/task-form/task-form.helpers.js";
import "date-fns/locale";
import "../../../../components/task-form/task-form.types.js";
import "../../../../components/task-form/assets/icons/Important.js";
import "../../../../components/task-form/assets/icons/TaskCategory.js";
import "../../../../components/task-form/assets/icons/TaskDescription.js";
import "../../../../components/task-form/assets/icons/TaskName.js";
import "../../../../components/task-form/theme/overrides/Button.js";
import "../../../../components/task-form/theme/overrides/PickersLayout.js";
import "../../../../components/task-form/theme/overrides/Menu.js";
import "../../../../components/task-form/theme/overrides/Autocomplete.js";
import "../../../../../themes/icon-button/icon-button.js";
import "../../../../../themes/tabs/tabs.js";
import "../../../../components/employee-select/components/employee-search-input/employee-search-input.js";
import "../../../../components/employee-select/components/employee-search-input/employee-search-input.styles.js";
import "../../../../components/employee-select/assets/icons/Search.js";
import "../../../../components/employee-select/employee-select.styles.js";
import "../../../../components/employee-select/assets/icons/Arrow.js";
import "../../../../components/employee-select/assets/icons/Employees.js";
import "formik";
import "../../../../components/ana/utils/helpers/getHasError.js";
import "../../../../components/ana/utils/hooks/useAddressSuggestions.js";
import "use-debounce";
import "../../../../components/ana/utils/helpers/googlePlaces.js";
import "../../../../components/ana/utils/helpers/places.js";
import "../../../../../type/Appointment.js";
import "../../../../components/ana/components/masked-date-input/masked-date-input.js";
import "react-text-mask";
import "../../../../components/ana/utils/entities/Form.js";
import "../../../../components/ana/utils/helpers/toBoolean.js";
import "date-fns/fp/format";
import "date-fns/isValid";
import "date-fns/parse";
import "../../../../components/ana/utils/helpers/createFields.js";
import "../../../../components/ana/utils/helpers/resetFields.js";
import "../../../../components/ana/utils/yup/yup.js";
import "../../../../../utils/pipe.js";
import "date-fns/fp";
import "libphonenumber-js/max";
import "libphonenumber-js/mobile";
import "../../../../components/ana/utils/helpers/predicates.js";
import "../../../../components/ana/utils/yup/emailValidation.js";
import "../../../../components/ana/utils/helpers/featureFlags.js";
import "../../../../components/ana/utils/helpers/getAgeFromBirthday.js";
import "../../../../components/ana/utils/yup/buildValidationSchema.js";
import "../../../../../type/Disease.js";
import "../../../../components/ana/utils/config/medicaments.js";
import "../../../../components/ana/utils/fields/wishesAndExpectations.js";
import "../../../../components/ana/utils/fields/consents.js";
import "../../../../components/ana/utils/fields/profileInterest.js";
import "@mui/x-date-pickers/StaticDatePicker/index.js";
import "date-fns/fp/formatWithOptions";
import "date-fns/locale/de";
import "date-fns/locale/en-US";
import "../../../../components/ana/utils/helpers/date.js";
import "date-fns/fp/startOfMonth";
import "date-fns/fp/subYears";
import "../../../../components/ana/components/date-picker-field/date-picker-field.styles.js";
import "react-window";
import "@mui/icons-material/ArrowDropDown.js";
import "libphonenumber-js";
import "../../../../components/ana/utils/helpers/phoneMetadata.js";
import "../../../../components/ana/components/phone-field/phone-field.styles.js";
import "../../../../components/ana/components/text-input/text-input.styles.js";
import "use-deep-compare";
import "fuse.js";
import "../../../../components/ana/components/insurance-field/insurance-field-helpers.js";
import "../../../../components/ana/components/insurance-field/Insurance-field.styles.js";
import "../../../../components/ana/utils/helpers/getIsRequired.js";
import "../../../../components/ana/components/form-layout/form-layout.js";
import "../../../../components/ana/utils/helpers/createField.js";
import "../../../../components/ana/components/checkbox-field/checkbox-field.js";
import "../../../../components/ana/components/select-field/select-field.js";
import "../../../../components/ana/components/select-input/select-input.js";
import "../../../../components/ana/components/text-field/text-field.js";
import "../../../../components/ana/components/submit-button/submit-button.js";
import "../../../../../components/loader/loader.js";
import "../../../../../components/loader/data.js";
import "../../../../../components/animation/animation.js";
import "../../../../../components/loader/loader.styles.js";
import "../../../../components/ana/utils/helpers/getFormInitialErrors.js";
import "../../../../components/ana/components/disease-group-field/disease-group-field.js";
import "../../../../components/ana/components/disease-field/disease-field.js";
import "../../../../components/ana/components/tag/tag.js";
import "@mui/icons-material/Cancel.js";
import "@mui/styles";
import "../../../../components/ana/components/disease-group-field/disease-group-field.helpers.js";
import "../../../../components/ana/utils/hooks/usePreConditionsToggle.js";
import "../../../../components/ana/utils/helpers/scrollToElementIfNotVisible.js";
import "../../../../components/ana/utils/helpers/isInViewport.js";
import "../../../../components/ana/forms/preconditions/preconditions.styles.js";
import "../../../../../type/Employee.js";
import "../../../../../utils/array.js";
import "fast-memoize";
import "../../../../../utils/employee/getUniqueByRoles.js";
import "lodash/reverse.js";
import "lodash/uniqBy.js";
import "../../../../components/website/common/button/button.js";
import "../../../../../hooks/useResponsive.js";
import "../../../../components/smileview-section/hooks/useWindowSize.js";
import "../../../../components/authentication/config.js";
import "../../../../components/authentication/helpers/time.js";
import "../../../../components/authentication/hooks/useStickyState.js";
import "axios";
import "../../../../components/authentication/helpers/credentials.js";
import "../../../../components/authentication/helpers/headers.js";
import "@emotion/styled";
import "../../appointment-details.types.js";
import "../../../../../components/icon/icon.js";
const AppointmentInfo = ({
  appointment,
  employee,
  isLoading,
  labels,
  onPatientClick,
  isOpenAppointment,
  isObfuscated,
  hints
}) => {
  const parsedBirthDate = useMemo(
    () => {
      var _a;
      return ((_a = appointment == null ? void 0 : appointment.patient) == null ? void 0 : _a.birthDate) ? format(parseISO(appointment.patient.birthDate), DATE_FORMATS.DAY_MONTH_YEAR) : "";
    },
    [appointment]
  );
  const isRegularAppointment = (appointment && "blocking" in appointment) ?? false;
  const isOpenForAvailyBooking = useMemo(
    // @ts-expect-error TODO:
    () => (!isOpenAppointment && isRegularAppointment && !(appointment == null ? void 0 : appointment.blocking)) ?? false,
    [appointment, isOpenAppointment]
  );
  const cancellationRows = useMemo(
    () => [
      // @ts-expect-error TODO:
      ...insertIf(isRegularAppointment && !!(appointment == null ? void 0 : appointment.cancellationType), {
        name: labels.cancellation[appointment && "cancellationType" in appointment && appointment.cancellationType || ""],
        Icon: CancellationTypeIcon
      }),
      // @ts-expect-error TODO:
      ...insertIf(isRegularAppointment && !!(appointment == null ? void 0 : appointment.cancelledBy), {
        // @ts-expect-error TODO:
        name: isRegularAppointment && (appointment == null ? void 0 : appointment.cancelledBy) || "",
        Icon: CancellationUserIcon,
        ...isRegularAppointment && // @ts-expect-error TODO:
        (appointment == null ? void 0 : appointment.cancelledAt) && {
          // @ts-expect-error TODO:
          details: format(parseISO(appointment.cancelledAt), `${DATE_FORMATS.DAY_MONTH_YEAR}, ${TIME_FORMATS.SHORT}`)
        }
      }),
      // @ts-expect-error TODO:
      ...insertIf(isRegularAppointment && !!(appointment == null ? void 0 : appointment.cancellationReason), {
        // @ts-expect-error TODO:
        name: isRegularAppointment && (appointment == null ? void 0 : appointment.cancellationReason) || "",
        Icon: CancellationReasonIcon
      })
    ],
    [appointment, employee]
  );
  const rows = useMemo(
    () => {
      var _a, _b, _c, _d, _e, _f;
      return [
        ...insertIf(isOpenForAvailyBooking, {
          name: labels.blocking.infoText,
          warning: true
        }),
        {
          name: `${(_a = appointment == null ? void 0 : appointment.patient) == null ? void 0 : _a.lastName}, ${(_b = appointment == null ? void 0 : appointment.patient) == null ? void 0 : _b.firstName}`,
          Icon: PatientIcon,
          details: `${parsedBirthDate} - ${labels.gender[((_c = appointment == null ? void 0 : appointment.patient) == null ? void 0 : _c.genderType) ?? ""]}`,
          onClick: onPatientClick,
          isName: true
        },
        {
          name: ((_d = appointment == null ? void 0 : appointment.patient) == null ? void 0 : _d.phoneNumber) ?? "",
          Icon: PhoneIcon
        },
        {
          name: (_e = appointment == null ? void 0 : appointment.patient) == null ? void 0 : _e.email,
          Icon: MailIcon
        },
        {
          name: labels.insurance[((_f = appointment == null ? void 0 : appointment.patient) == null ? void 0 : _f.insuranceType) ?? ""],
          Icon: InsuranceIcon
        },
        ...insertIf(!!employee, {
          name: `${employee == null ? void 0 : employee.displayName}`,
          avatar: employee == null ? void 0 : employee.imageUrl
        }),
        {
          name: (appointment == null ? void 0 : appointment.treatmentName) ?? "",
          Icon: TreatmentIcon,
          ...appointment && "durationInMinutes" in appointment && {
            details: `${appointment.durationInMinutes} ${labels.minutes}`,
            DetailsIcon: ClockIcon
          }
        },
        ...insertIf(!!(appointment == null ? void 0 : appointment.comment) || !!hints, {
          name: ((appointment == null ? void 0 : appointment.comment) || "") + (hints || ""),
          Icon: CommentIcon
        }),
        ...insertIf(isOpenForAvailyBooking, {
          name: labels.blocking.fieldText,
          Icon: WarningIcon
        }),
        ...insertIf(!!isOpenAppointment, {
          ...appointment && "createdBy" in appointment && {
            name: appointment.createdBy
          },
          Icon: CreatedByIcon,
          ...appointment && "createdAt" in appointment && {
            details: format(parseISO(appointment.createdAt), `${DATE_FORMATS.DAY_MONTH_YEAR}, ${TIME_FORMATS.SHORT}`)
          }
        })
      ];
    },
    [appointment, employee, isOpenForAvailyBooking]
  );
  const handleClick = (onClick) => (event) => {
    event.stopPropagation();
    onClick == null ? void 0 : onClick();
  };
  if (isLoading)
    return /* @__PURE__ */ jsx(AppointmentInfoSkeleton, {});
  return /* @__PURE__ */ jsxs("div", { children: [
    !!cancellationRows.length && !isLoading && /* @__PURE__ */ jsxs(CancelationDetailsContainer, { children: [
      /* @__PURE__ */ jsx(Typography, { variant: "Lato Emphasized 1", children: labels.title.cancellation }),
      cancellationRows.map(({ Icon, name, details, DetailsIcon }) => /* @__PURE__ */ jsxs(Container, { children: [
        Icon && /* @__PURE__ */ jsx(IconContainer, { children: /* @__PURE__ */ jsx(Icon, {}) }),
        /* @__PURE__ */ jsxs(PatientDetailsContainer, { children: [
          /* @__PURE__ */ jsx(Typography, { variant: "Lato Body 1", children: name }),
          details && /* @__PURE__ */ jsxs("div", { children: [
            DetailsIcon && /* @__PURE__ */ jsx(DetailsIcon, {}),
            /* @__PURE__ */ jsx(PatientAdditionalDetails, { variant: "Lato Body 2", children: details })
          ] })
        ] })
      ] }, name))
    ] }),
    (appointment == null ? void 0 : appointment.risky) && /* @__PURE__ */ jsx(RiskyAppointmentWarning, { severity: "warning", children: labels.risky.infoText }),
    !isLoading && rows.map(({ Icon, name, details, onClick, DetailsIcon, isName, ...rest }) => /* @__PURE__ */ jsxs(Container, { children: [
      Icon && /* @__PURE__ */ jsx(IconContainer, { children: /* @__PURE__ */ jsx(Icon, {}) }),
      rest.hasOwnProperty("avatar") && /* @__PURE__ */ jsx(AvatarContainer, { children: /* @__PURE__ */ jsx(Avatar, { src: (rest == null ? void 0 : rest.avatar) ?? "", size: "s", children: getNameInitials(name) }) }),
      rest.warning && /* @__PURE__ */ jsx(Warning, { severity: "warning", children: name }),
      !rest.warning && /* @__PURE__ */ jsxs(PatientDetailsContainer, { children: [
        /* @__PURE__ */ jsx(MainText, { variant: "Lato Body 1", onClick: handleClick(onClick), isClickable: !!onClick, children: isName ? /* @__PURE__ */ jsx(ObfuscatedText, { isVisible: !isObfuscated, children: name }) : name }),
        details && /* @__PURE__ */ jsxs(DetailsWrapper, { children: [
          DetailsIcon && /* @__PURE__ */ jsx(DetailsIcon, {}),
          /* @__PURE__ */ jsx(PatientAdditionalDetails, { variant: "Lato Body 2", children: details })
        ] })
      ] })
    ] }, name))
  ] });
};
export {
  AppointmentInfo
};
